var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.25C9.41421 1.25 9.75 1.58579 9.75 2V2.25H16C16.4142 2.25 16.75 2.58579 16.75 3V8C16.75 8.41421 16.4142 8.75 16 8.75H9.75V10.1951C10.1138 10.3626 10.4383 10.638 10.6729 11.0213L13.7595 16.0644L15.0692 14.0384C15.9109 12.7365 17.8065 12.7365 18.6481 14.0384L21.6517 18.6845C22.5746 20.1121 21.5556 22 19.8622 22H4.13762C2.46795 22 1.4449 20.1592 2.31997 18.7294L7.03759 11.0213C7.33288 10.5388 7.77068 10.2273 8.25 10.0867V2C8.25 1.58579 8.58579 1.25 9 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.c81e23f69dee8be5ba3c91b353058e37.svg";
export { ForwardRef as ReactComponent };